import {ReactNode} from 'react';

export const sizeClass = {
    sm: 'py-1 px-2',
    md: 'p-2',
    lg: 'p-3',
};

export const styleClasses = {
    light:
        'bg-transparent text-gray-900 stroke-gray-900 gap-2 border-gray-100 hover:bg-gray-100 hover:border-gray-100 focus:bg-transparent hover:disabled:bg-white disabled:text-gray-900 disabled:hover:border-transparent',
    primary:
        'bg-green-400 text-green-50 border-green-400 hover:bg-green-500 hover:border-green-500 focus:bg-green-500 focus:border-green-500 disabled:bg-transparent disabled:text-gray-900  hover:disabled:bg-green-100 hover:disabled:text-gray-900',
    dark: 'bg-gray-900 text-white border-gray-900 hover:bg-gray-700 hover:bg-gray-700 focus:bg-gray-800 focus:bg-gray-800 disabled:bg-gray-100  disabled:border-gray-100 disabled:text-white hover:disabled:bg-transparent hover:disabled:border-gray-100 hover:disabled:text-gray-100',
    danger:
        'bg-red-600 text-white border-red-600 hover:bg-red-500 focus:bg-red-800 disabled:bg-transparent disabled:text-red-900 hover:disabled:bg-transparent',
    'danger-light':
        'bg-red-50 border-red-600 text-red-600 hover:bg-red-50 focus:bg-red-100 disabled:bg-red-50 disabled:text-red-500 hover:disabled:bg-red-50',
    green:
        'bg-green-100 text-gray-900 border-transparent hover:bg-green-200 focus:bg-green-300 disabled:bg-transparent disabled:text-gray-900  hover:disabled:bg-green-100 hover:disabled:text-gray-900',
    impersonating: 'impersonating-gradient text-white stroke-white'
};

export interface ButtonBaseProps {
    style: 'light' | 'primary' | 'dark' | 'danger' | 'green' | 'danger-light' | 'impersonating';
    size: 'sm' | 'md' | 'lg';
    disabled?: boolean;
    children?: ReactNode;
    className?: string;
}
